// In-memory, not localStorage: the token is always re-derivable from the
// /embed/:token URL, so persisting it buys nothing and risks a stale/expired
// token leaking into an unrelated tab or surviving past its Redis-backed TTL.
let embedToken: string | null = null;

export const getEmbedToken = (): string | null => embedToken;

export const setEmbedToken = (token: string): void => {
  embedToken = token;
};

export const clearEmbedToken = (): void => {
  embedToken = null;
};
